import { Box, Button, ButtonGroup, TextField } from '@mui/material';
import React from 'react';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';

interface GeneralNotesComponentProps {
	// Define your component props here
}

const GeneralNotesComponent: React.FC<GeneralNotesComponentProps> = () => {
	// Add your component logic here
	const {
		generalNotesInfo,
		handleGeneralStatusChange,
		handleGeneralNotesChange,
	} = useActivePatrolData();

	const getVariant = (status: PatrolGeneralStatus) => {
		if (generalNotesInfo.generalStatus === status) {
			return 'contained';
		}
		return 'outlined';
	};

	return (
		<Box
			style={{
				margin: '0.25rem',
				display: 'flex',
				flexDirection: 'column',
				gap: '0.5rem',
			}}
		>
			<ButtonGroup
				variant="outlined"
				aria-label="Basic button group"
				fullWidth
			>
				<Button
					variant={getVariant('Clear')}
					onClick={() => handleGeneralStatusChange('Clear')}
					color="success"
				>
					Clear
				</Button>
				<Button
					variant={getVariant('Warning')}
					onClick={() => handleGeneralStatusChange('Warning')}
					color="warning"
				>
					Warning
				</Button>
				<Button
					variant={getVariant('Emergency')}
					onClick={() => handleGeneralStatusChange('Emergency')}
					color="error"
				>
					Emergency
				</Button>
			</ButtonGroup>
			<TextField
				value={generalNotesInfo.generalNotes.text}
				onChange={(e) => handleGeneralNotesChange(e.target.value)}
				label="General notes about the patrol"
				fullWidth
				multiline
				rows={5}
			/>
		</Box>
	);
};

export default GeneralNotesComponent;
